module.exports = __webpack_public_path__ + "static/img/performance-detail.ae2fdc34.png";